module.exports = __webpack_public_path__ + "img/logo.e4411d99.png";